<template>
  <v-date-picker
    :first-day-of-week="0"
    v-model="date"
    :day-format="dayFormatter"
    flat
    locale="ja"
    color="primary"
  ></v-date-picker>
</template>

<script>
export default {
  name: 'PickerDate',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    date: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    dayFormatter() {
      return date => new Date(date).getDate()
    },
  },
}
</script>
